module.exports = __webpack_public_path__ + "img/example-education-zones.5af72966.png";